import styled from 'styled-components';

export const FormGroupMarginWrapper = styled.div`
  .p-form-group {
    margin: 0px 0px 0.75rem;
  }
`;
